import React from 'react';

import { Pressable, Text } from '@rbilabs/universal-components';
import { GestureResponderEvent } from 'react-native';

import { MethodContainer } from 'components/payment-method-option/styled';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { primitive } from 'styles/constants/primitives';

import { IPaymentMethodAddNewItemOptionProps } from './types';

export const PaymentMethodAddNewItemOption = ({
  text,
  Icon,
  onPress,
  testID,
  selected = false,
  isDisabled = false,
}: IPaymentMethodAddNewItemOptionProps) => {
  const handleOnPress = (e: GestureResponderEvent) => {
    if (!onPress) {
      return;
    }
    if (!selected) {
      logButtonClick({
        attributes: {
          Name: text,
          name: text,
          component: ClickEventComponentNames.BUTTON,
        },
      });
    }
    onPress(e);
  };

  return (
    <Pressable
      onPress={handleOnPress}
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={text}
    >
      <MethodContainer>
        {Icon}
        <Text
          marginLeft={'$2'}
          color={isDisabled ? primitive.$blackOpacity30 : primitive.bk.$bbqBrown}
        >
          {text}
        </Text>
      </MethodContainer>
    </Pressable>
  );
};
